import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const FEATURES = [
  { icon: '📊', title: 'Replay Trading', desc: 'Replay historical data bar by bar. Practice without risking real capital.' },
  { icon: '📐', title: '50+ Drawing Tools', desc: 'Fibonacci, Elliott Waves, channels, harmonic patterns — just like TradingView.' },
  { icon: '📈', title: '47 Indicators', desc: 'RSI, MACD, Bollinger, Ichimoku, Supertrend and more. Create your own custom formulas.' },
  { icon: '🏆', title: 'Prop Firm Challenge', desc: 'Simulate FTMO challenges, practice drawdown rules and profit targets.' },
  { icon: '🤖', title: 'AI Analysis', desc: 'Automatic market analysis powered by AI. Sentiment, confluences, patterns.' },
  { icon: '📓', title: 'Trading Journal', desc: 'Every trade is recorded with screenshots, tags, and detailed statistics.' },
  { icon: '⚡', title: 'Strategy Tester', desc: 'Backtest your strategies with a visual condition editor. Instant results.' },
  { icon: '📉', title: 'Volume & Market Profile', desc: 'POC, VAH, VAL, TPO — institutional tools to identify key levels.' },
];

const STATS = [
  { value: '47', label: 'Indicators' },
  { value: '50+', label: 'Drawing Tools' },
  { value: '8', label: 'Chart Types' },
  { value: '100%', label: 'Free' },
];

export default function LandingPage() {
  return (
    <>
      <Helmet>
        <title>Tradrin — Professional Trading Simulator</title>
        <meta name="description" content="Practice trading with the most complete simulator. Historical replay, 47 indicators, TradingView drawing tools, Prop Firm Challenge, AI analysis. 100% free." />
        <meta property="og:title" content="Tradrin — Professional Trading Simulator" />
        <meta property="og:description" content="The most complete trading simulator. Replay, indicators, drawings, backtesting, journal. Free." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://tradrin.com" />
        <link rel="canonical" href="https://tradrin.com" />
      </Helmet>

      <div className="landing">
        <nav className="landing-nav">
          <Link to="/" className="landing-logo">Tradrin</Link>
          <div className="landing-nav-links">
            <a href="#features">Features</a>
            <Link to="/faq">FAQ</Link>
            <Link to="/blog">Blog</Link>
            <Link to="/login" className="landing-nav-login">Sign In</Link>
            <Link to="/register" className="landing-nav-cta">Start Free</Link>
          </div>
        </nav>

        <section className="landing-hero">
          <div className="landing-hero-content">
            <div className="landing-badge">Trading Simulator</div>
            <h1>Practice trading<br /><span className="landing-gradient">without risking a cent</span></h1>
            <p className="landing-hero-sub">
              Historical replay, 47 technical indicators, professional drawing tools,
              Prop Firm Challenge, automated backtesting and smart journal.
            </p>
            <div className="landing-hero-actions">
              <Link to="/register" className="landing-btn-primary">Start Free</Link>
              <Link to="/login" className="landing-btn-secondary">Sign In</Link>
            </div>
          </div>
          <div className="landing-hero-visual">
            <div className="landing-chart-mockup">
              <div className="mockup-bar" />
              <div className="mockup-candles">
                {[40,55,45,60,50,70,65,80,72,85,78,90,82,95].map((h, i) => (
                  <div key={i} className={`mockup-candle ${i % 3 === 0 ? 'red' : 'green'}`} style={{ height: `${h}%` }} />
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="landing-stats">
          {STATS.map((s, i) => (
            <div key={i} className="landing-stat">
              <span className="landing-stat-value">{s.value}</span>
              <span className="landing-stat-label">{s.label}</span>
            </div>
          ))}
        </section>

        <section className="landing-features" id="features">
          <h2>Everything You Need</h2>
          <p className="landing-features-sub">A complete platform to practice trading like a professional</p>
          <div className="landing-features-grid">
            {FEATURES.map((f, i) => (
              <div key={i} className="landing-feature-card">
                <span className="landing-feature-icon">{f.icon}</span>
                <h3>{f.title}</h3>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="landing-cta">
          <h2>Ready to improve your trading?</h2>
          <p>Join traders who practice every day on Tradrin.</p>
          <Link to="/register" className="landing-btn-primary landing-btn-lg">Create a Free Account</Link>
        </section>

        <footer className="landing-footer">
          <div className="landing-footer-grid">
            <div>
              <h4>Tradrin</h4>
              <p>Professional trading simulator. Practice, analyze, progress.</p>
            </div>
            <div>
              <h4>Product</h4>
              <Link to="/register">Get Started</Link>
              <a href="#features">Features</a>
              <Link to="/faq">FAQ</Link>
              <Link to="/blog">Blog</Link>
            </div>
            <div>
              <h4>Contact</h4>
              <a href="mailto:contact@tradrin.com">contact@tradrin.com</a>
            </div>
          </div>
          <div className="landing-footer-bottom">
            <span>&copy; {new Date().getFullYear()} Tradrin. All rights reserved.</span>
          </div>
        </footer>
      </div>
    </>
  );
}
